export default __webpack_public_path__ + "static/disabled-dont-0d97ad01dc92899aeacacf316dedb0f67d865e600b43320f2637acbbb9d80393.png";